import { render, staticRenderFns } from "./control3ReadReport.vue?vue&type=template&id=5be7f366&scoped=true&"
import script from "./control3ReadReport.vue?vue&type=script&lang=js&"
export * from "./control3ReadReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be7f366",
  null
  
)

export default component.exports